import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, ArrowRight } from 'lucide-react';
import { cities } from '../mock';
import { blogPosts } from '../servicesData';

export default function CitiesAndArticles() {
  return (
    <>
      <section className="bg-gradient-to-b from-[#f7fbfd] to-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-10">
            <div className="text-xs font-bold uppercase tracking-widest text-orange-600">Nearby experts</div>
            <h2 className="text-2xl md:text-4xl font-extrabold text-[#0b3d5b] mt-2">Choose Your City for CA Service</h2>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4">
            {cities.map((c) => (
              <Link
                key={c.name}
                to={`/city/${c.name.toLowerCase()}`}
                className="group flex flex-col items-center bg-white rounded-2xl border border-slate-100 p-4 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all"
              >
                <div className="w-16 h-16 rounded-full bg-gradient-to-br from-orange-100 to-orange-50 flex items-center justify-center group-hover:from-orange-500 group-hover:to-orange-600 transition-colors">
                  <MapPin className="w-7 h-7 text-orange-600 group-hover:text-white transition-colors" />
                </div>
                <div className="mt-3 font-semibold text-[#0b3d5b] group-hover:text-orange-600">{c.name}</div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-white py-16 border-t border-slate-100">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-end justify-between mb-8 flex-wrap gap-3">
            <div>
              <div className="text-xs font-bold uppercase tracking-widest text-orange-600">Insights</div>
              <h2 className="text-2xl md:text-4xl font-extrabold text-[#0b3d5b] mt-2">Popular Articles</h2>
            </div>
      <a href="#" className="text-sm font-semibold text-orange-600 hover:text-orange-700 flex items-center gap-1">
              View all <ArrowRight className="w-4 h-4" />
            </a>
          </div>
          <div className="grid md:grid-cols-3 gap-5">
            {blogPosts.map((a) => (
              <Link key={a.slug} to={`/blog/${a.slug}`} className="group bg-white rounded-2xl border border-slate-100 p-6 shadow-sm hover:shadow-lg hover:border-orange-200 transition-all">
                <div className="h-1 w-10 rounded bg-orange-500 mb-4" />
                <h3 className="font-bold text-[#0b3d5b] text-lg leading-snug group-hover:text-orange-600">{a.title}</h3>
                <p className="mt-3 text-sm text-slate-600 leading-relaxed">{a.excerpt}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-orange-600">Read more <ArrowRight className="w-4 h-4" /></span>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
